import {
  FETCH_PROFILE_INFO,
  FETCH_PROFILE_INFO_SUCCESS,
  FETCH_PROFILE_INFO_FAILED,
  RESET
} from "../actions/types";

export interface ProfileInfo {
  displayName: string;
  email: string;
  emailVerified: boolean;
  gameId: string;
  isOnline: boolean;
  uid: string;
  username: string;
  userpic: string;
}

export interface profileActionInterface {
  type: string;
  payload?: ProfileInfo;
}

export interface ProfileInterface {
  errorFetching: string;
  loading: boolean;
  info?: ProfileInfo;
}

const INITIAL_STATE: ProfileInterface = {
  errorFetching: "",
  loading: false,
  info: undefined
};

const profile = (
  state: ProfileInterface = INITIAL_STATE,
  action: profileActionInterface
): ProfileInterface => {
  switch (action.type) {
    case FETCH_PROFILE_INFO:
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    case FETCH_PROFILE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        errorFetching: "",
        info: action.payload
      };
    case FETCH_PROFILE_INFO_FAILED:
      return {
        ...state,
        loading: false,
        errorFetching: "",
        info: undefined
      };
    case RESET:
      return {
        ...state,
        loading: false,
        errorFetching: "",
        info: undefined
      };

    default:
      return state;
  }
};

export default profile;
